
    <!--
 * 电脑端-复制
 * @LastEditTime: Thu Sep 19 2024 16:44:01 GMT+0800 (中国标准时间)
 -->
 <template>
  <a id="u_c_9B8817" href="javascript:;" :class="[`normal`,`u_c_9B8817`]" @click="u_c_9B8817_event_86KO17($event)"><div id="u_c_7Z4518"  v-show="compData.tipState" :class="[`normal`,`u_c_7Z4518`]" >{{`${ compData.copysucc }`}}</div></a>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"tipState":false,"giftCode":123123,"copysucc":"复制成功（自动替换多语言）"},"en-US":{"tipState":false,"giftCode":`MUDE4PC`,"copysucc":"复制成功（自动替换多语言）"}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const { copy, copied } = vueUse.useClipboard()

const SUCC_TIPS = {
  default: "Copied to clipboard",
  "ar-SR": "تم النسخ إلى الحافظة",
  "id-ID": "Disalin ke papan klip",
  "ja-JP": "コピーしました",
  "ko-KR": "클립보드로 복사되었습니다.",
  "th-TH": "คัดลอกไปยังคลิปบอร์ดแล้ว",
  "vi-VN": "Đã sao chép",
  "zh-CN": "已复制至剪贴板",
  "zh-TW": "已複製至剪貼板",
}

compData.copysucc = SUCC_TIPS[curLang] || SUCC_TIPS.default

const gaClickUpload = inject("gaClickUpload", () => {})

watch(
  () => copied.value,
  (value) => {
    if (value) {
      compData.tipState = true
    }
  }
)

const exccopy = async () => {
  try {
    copy(compData.giftCode)
  } catch (e) {
    console.log(e)
  }
}

watch(
  () => compData.tipState,
  (value) => {
    if (value) {
      setTimeout(() => {
        compData.tipState = false
      }, 2000)
    }
  }
)
;
      // 复制的click事件
      const u_c_9B8817_event_86KO17= async (e)=>{
        try {exccopy();
let gtm_filter_res = utils.getCookie(`zz_gtm_filter_${pageData.gameId}_copy`)
if (!gtm_filter_res) {
  gaClickUpload('gtm-click-copy')
  if (pageData.gameId) {
    utils.setCookie(`zz_gtm_filter_${pageData.gameId}_copy`, 1, 30)
  }
}
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_9B8817.normal{
position:absolute;
width:3.52vh;
height:3.89vh;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16602889214213.png);
background-size:contain;
background-repeat:no-repeat;
background-position:center;
top:71.48vh;
left:50%;
transform:translateX(-50%);
margin-left:48.52vh;

}
}.default{
.u_c_7Z4518.normal{
position:absolute;
font-size:1.67vh;
color:white;
bottom:110%;
left:50%;
transform:translateX(-50%);
white-space:nowrap;
padding:0.74vh 1.85vh;
background:#555;
border-radius:12px;

}
}.en-US{
.u_c_9B8817.normal{
position:absolute;
width:3.52vh;
height:3.89vh;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16602889214213.png);
background-size:contain;
background-repeat:no-repeat;
background-position:center;
top:71.48vh;
left:50%;
transform:translateX(-50%);
margin-left:48.52vh;

}
}.en-US{
.u_c_7Z4518.normal{
position:absolute;
font-size:1.67vh;
color:white;
bottom:110%;
left:50%;
transform:translateX(-50%);
white-space:nowrap;
padding:0.74vh 1.85vh;
background:#555;
border-radius:12px;

}
}
</style>
